import Vue from 'vue'
import ClickOutside from 'vue-click-outside'
Vue.use(ClickOutside);
